import { render, staticRenderFns } from "./ClientPortalNavbar.vue?vue&type=template&id=b2b5409a&"
import script from "./ClientPortalNavbar.vue?vue&type=script&lang=js&"
export * from "./ClientPortalNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports